import React, { useEffect, useState } from 'react';
import BannerMain from '../../components/BannerMain';
import Carousel from '../../components/Carousel';
import PageDefault from "../../components/PageDefault";
import categoriasRepository from '../../repositories/categorias';


function Home() {


    const [dadosIniciais, setDadosInicias ] = useState({
        categorias: [],
    });


    useEffect(() => {
        categoriasRepository.getAllWithVideos()
            .then( (categoriasComVideos) => {
                setDadosInicias(categoriasComVideos);
            })
            .catch((err) => {
                console.error(err.message);
            })
    }, [])

  return (
    <PageDefault style={{ background: '#141414'}} paddingAll={0}>
       
        {dadosIniciais.length === 0 && (<div>Loading....</div>)}

        {/* {dadosIniciais.map((categoria,indice) => {
                if(indice === 0 ) {
                    return(
                        <div key={categoria.id}>
                                <BannerMain 
                                    videoTitle={dadosIniciais[0].videos[0].titulo}
                                    url={dadosIniciais[0].videos[0].url}
                                    videDescription={"O que é Front-End?"}
                                />
                                <Carousel 
                                    ignoreFirstVideo
                                    category={dadosIniciais[0]}
                                />
                        </div>
                    );
                }
                return (
                    <Carousel 
                        key={categoria.id}
                        category={categoria}
                    />
                )
            })
        }
       */}
        {/*
        <Carousel 
            ignoreFirstVideo
            category={dadosIniciais.categorias[1]}
        />
                <Carousel 
            ignoreFirstVideo
            category={dadosInicias.categorias[2]}
        />
                <Carousel 
            ignoreFirstVideo
            category={dadosInicias.categorias[3]}
        /> */}
    </PageDefault>
  );
}

export default Home;
